import { ApplicationContextManager } from './static/appfactory3';
import { AppWindow } from './appwindow';
import { initializeCheckpointClient } from './static/globalAuth';
import { CHECKPOINT_APPS } from '../checkpoint/app-names';

export const app = new ApplicationContextManager({});
app.window = {} as AppWindow;


export const checkpoint = initializeCheckpointClient(CHECKPOINT_APPS.GRAPH_EDITOR);

